import { render, staticRenderFns } from "./UXMediaTemp.vue?vue&type=template&id=ebda48ae&scoped=true"
import script from "./UXMediaTemp.vue?vue&type=script&lang=js"
export * from "./UXMediaTemp.vue?vue&type=script&lang=js"
import style0 from "./UXMediaTemp.vue?vue&type=style&index=0&id=ebda48ae&prod&lang=sass&scoped=true"
import style1 from "./UXMediaTemp.vue?vue&type=style&index=1&id=ebda48ae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebda48ae",
  null
  
)

export default component.exports